/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSaveArticle as ResolvedStandaloneSaveArticle } from 'base/components/standalone/SaveArticle';

export const SaveArticle: typeof ResolvedStandaloneSaveArticle = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSaveArticle {...props} />
        </ErrorBoundary>
    );
});

export type SaveArticleProps = PropsFromComponent<typeof SaveArticle>;

/** @deprecated Use slot architecture instead */
export const SaveArticleWith = (extras: DynamicStandaloneExtras): typeof SaveArticle => {
    return function SaveArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SaveArticle');
        return <ResolvedStandaloneSaveArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}